import { Link } from "react-router-dom";
import type { ReactNode } from "react";
import { COLOR_MAP } from "./menu.config";
import { IconBadge } from "./IconBadge";

export function SidebarLink({
  to,
  icon,
  label,
  active,
  disabled,
  colorKey,
  indentLevel = 0,
}: {
  to: string;
  icon?: ReactNode;
  label: string;
  active?: boolean;
  disabled?: boolean;
  colorKey?: keyof typeof COLOR_MAP | null;
  indentLevel?: number;
}) {
  const c = colorKey ? COLOR_MAP[colorKey] : null;
  const activeBg = c ? c.activeBg : "bg-sky-50";
  const activeText = c ? c.activeText : "text-sky-700";
  const rail = c ? c.rail : "bg-sky-500";

  const base = "group flex items-center gap-3 rounded-lg pr-3 py-2 text-sm transition relative";
  const padLeft =
    indentLevel === 0 ? "pl-3" :
    indentLevel === 1 ? "pl-6" :
    indentLevel === 2 ? "pl-9" : "pl-12";

  if (disabled) {
    return (
      <div
        aria-disabled
        className={`${base} ${padLeft} text-gray-400 bg-gray-50 cursor-not-allowed opacity-60 pointer-events-none`}
        title="Coming soon"
      >
        <IconBadge colorKey={colorKey || null}>{icon}</IconBadge>
        <span>{label}</span>
      </div>
    );
  }

  return (
    <Link
      to={to}
      className={`${base} ${padLeft} ${active ? `${activeBg} ${activeText}` : "text-gray-700 hover:bg-gray-100"}`}
    >
      {/* Active rail */}
      <span
        className={`absolute left-0 top-1/2 -translate-y-1/2 h-5 w-1 rounded-full ${active ? rail : "bg-transparent"}`}
      />
      <IconBadge colorKey={colorKey || null}>{icon}</IconBadge>
      <span className={active ? "font-medium" : ""}>{label}</span>
    </Link>
  );
}
